// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3C9s3","amount":"Amount_amount__3Fak6","tip":"Amount_tip__3vGfn","tipHeader":"Amount_tipHeader__1vH8O","tipsWrap":"Amount_tipsWrap__1dw9t"};